import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { SocketProvider } from './context/SocketContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ReadingsPage from './pages/ReadingsPage';
import MedidoresPage from './pages/MedidoresPage';
import UsersPage from './pages/UsersPage';
import StatsPage from './pages/StatsPage';
import ApprovalsPage from './pages/ApprovalsPage';
import RoutesPage from './pages/RoutesPage';
import MapaRutasPage from './pages/MapaRutasPage';
import IncidentsPage from './pages/IncidentsPage';
import MedicionesPage from './pages/MedicionesPage';
import RevisionRapidaPage from './pages/RevisionRapidaPage';
import TarifasPage from './pages/TarifasPage';
import RutasCompletadasPage from './pages/RutasCompletadasPage';
import RevisionPage from './pages/RevisionPage';
import GestionRutaPage from './pages/GestionRutaPage';
import MapaOptimizadoPage from './pages/MapaOptimizadoPage';
import ChatPage from './pages/ChatPage';
import SoportePage from './pages/SoportePage';
import AdminHubPage from './pages/AdminHubPage';
import WhatsappPage from './pages/WhatsappPage';
import WhatsappAdminPage from './pages/WhatsappAdminPage';
import MedidoresManualPage from './pages/MedidoresManualPage';
import FacturacionPage from './pages/FacturacionPage';

const WHATSAPP_ROLE = "administrador-whatsapp";

function PrivateRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === WHATSAPP_ROLE) return <Navigate to="/whatsapp" replace />;
  return children;
}

function WhatsappRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== WHATSAPP_ROLE && user.role !== "admin" && user.role !== "admin-plus")
    return <Navigate to="/dashboard" replace />;
  return children;
}

function AdminPlusRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin-plus") return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  const defaultRedirect = user?.role === WHATSAPP_ROLE ? "/whatsapp" : "/medidores";

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to={defaultRedirect} /> : <LoginPage />} />
      <Route path="/whatsapp" element={<WhatsappRoute><WhatsappPage /></WhatsappRoute>} />
      <Route path="/" element={<Navigate to={user?.role === WHATSAPP_ROLE ? "/whatsapp" : "/medidores"} />} />
      <Route path="/dashboard" element={<Navigate to="/medidores" replace />} />
      <Route path="/dashboard" element={
        <PrivateRoute><Layout><DashboardPage /></Layout></PrivateRoute>
      } />
      <Route path="/medidores" element={
        <PrivateRoute><Layout><MedidoresPage /></Layout></PrivateRoute>
      } />
      <Route path="/readings" element={<Navigate to="/medidores" replace />} />
      <Route path="/medidores-manual" element={<Navigate to="/medidores" replace />} />
      <Route path="/users"     element={<Navigate to="/panel" state={{ tab: "usuarios" }}     replace />} />
      <Route path="/stats"     element={<Navigate to="/panel" state={{ tab: "estadisticas" }} replace />} />
      <Route path="/approvals" element={<Navigate to="/panel" state={{ tab: "solicitudes" }}  replace />} />
      <Route path="/panel" element={
        <PrivateRoute><Layout><AdminHubPage /></Layout></PrivateRoute>
      } />
      <Route path="/mapa-rutas" element={
        <PrivateRoute><Layout><MapaRutasPage /></Layout></PrivateRoute>
      } />
      <Route path="/routes" element={<Navigate to="/mapa-rutas" replace />} />
      <Route path="/incidents" element={<Navigate to="/gestion-ruta" state={{ tab: "incidencias" }} replace />} />
      <Route path="/mediciones" element={<Navigate to="/gestion-ruta" state={{ tab: "auditorias" }} replace />} />
      <Route path="/revision-rapida" element={
        <PrivateRoute><Layout><RevisionRapidaPage /></Layout></PrivateRoute>
      } />
      <Route path="/tarifas" element={
        <PrivateRoute><Layout><TarifasPage /></Layout></PrivateRoute>
      } />
      <Route path="/gestion-ruta" element={
        <PrivateRoute><Layout><GestionRutaPage /></Layout></PrivateRoute>
      } />
      {/* Redirects para mantener compatibilidad con links existentes */}
      <Route path="/rutas-completadas" element={<Navigate to="/gestion-ruta" replace />} />
      <Route path="/revision" element={<Navigate to="/gestion-ruta" replace />} />
      <Route path="/mapa-optimizado" element={<Navigate to="/mapa-rutas" replace />} />
      <Route path="/chat"    element={<Navigate to="/panel" replace />} />
      <Route path="/soporte" element={<Navigate to="/panel" replace />} />
      <Route path="/whatsapp-admin" element={
        <AdminPlusRoute><Layout><WhatsappAdminPage /></Layout></AdminPlusRoute>
      } />
      <Route path="/medidores-manual" element={
        <PrivateRoute><Layout><MedidoresManualPage /></Layout></PrivateRoute>
      } />
      <Route path="/facturacion" element={
        <PrivateRoute><Layout><FacturacionPage /></Layout></PrivateRoute>
      } />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <SocketProvider>
            <AppRoutes />
          </SocketProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
